const items = [
  "Canapés & fauteuils",
  "Matelas toutes tailles",
  "Moquettes",
  "Sièges & habitacle auto",
  "Tapis",
  "Taches & odeurs",
  "Anti-acariens",
  "À domicile",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-slate-200 bg-[#0B131E] py-5"
    >
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap px-8 font-serif text-xl italic tracking-wide text-slate-300 sm:text-2xl">
              {item}
            </span>
            <img
              src="/logo.jpg"
              alt=""
              aria-hidden="true"
              className="h-5 w-5 shrink-0 rounded-full object-cover"
            />
          </span>
        ))}
      </div>
    </div>
  );
}
